import React, { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import './CarruselSlides.scss';
import Pagination from './Pagination';
import ImageWebp from '../../utils/imageProcess/ImageWebp'

//import { width } from "window-size";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = {
  root: {
    position: 'relative',
    height: 'fit-content',
    /* marginBottom: '35px', */
    width: '100%',
  },
  slide: {
    padding: 15,
    /* minHeight: 100, */
    color: '#fff',
  },
  /*slide1: {
    backgroundColor: "#FEA900"
  },
  slide2: {
    backgroundColor: "#B3DC4A"
  },
  slide3: {
    backgroundColor: "#6AC0FF"
  }*/
};

function CarruselSlides(props) {
  const { styleSlider, pathImg1, pathImg2, pathImg3, item1, item2, item3 ,item4, item5 } = props;

  const [index, setIndex] = useState(0);

  const handleChangeIndex = index => {
    setIndex(index);
  };

  let classNameCont = 'slider_cont';
  let classNameDots = 'slider_dots';
  let claseNameMargin = 'slider_img';

  if (styleSlider == 1) {
    classNameCont = 'slider_cont slider_cont--reverse';
    classNameDots = 'slider_dots slider_dots--reverse';
    claseNameMargin = 'slider_img img_reverse';
  }


  return (
    <div style={styles.root} className="text-container">
      <AutoPlaySwipeableViews
        interval={14000}
        index={index}
        onChangeIndex={handleChangeIndex}
      >
        <div className="slider">
          <figure className={claseNameMargin}>
          <ImageWebp
                srcWebp={item1.pathImgWebp}
                src={item1.pathImg}
                alt={item1.alts}
              /> 
            
          </figure>
          <div className={classNameCont}>
            <div className="slider_aux">
              <div className="slider_comillas">
                <p>“</p>
              </div>

              <div className="slider_info">
                <p className="slider_info_title">
                  {item1.summary}
                </p>
                <p className="slider_info_opinion">
                  {item1.review}
                </p>
                <p className="slider_info_autor">
                  {item1.name}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="slider">
          <figure className={claseNameMargin}>
          <ImageWebp
                srcWebp={item2.pathImgWebp}
                src={item2.pathImg}
                alt={item2.alts}
              /> 
          </figure>
          <div className={classNameCont}>
            <div className="slider_aux">
              <div className="slider_comillas">
                <p>“</p>
              </div>

              <div className="slider_info">
                <p className="slider_info_title">{item2.summary}</p>
                <p className="slider_info_opinion">
                  {item2.review}
                </p>
                <p className="slider_info_autor">
                  {item2.name}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="slider">
          <figure className={claseNameMargin}>
          <ImageWebp
                srcWebp={item3.pathImgWebp}
                src={item3.pathImg}
                alt={item3.alts}
              /> 
          </figure>
          <div className={classNameCont}>
            <div className="slider_aux">
              <div className="slider_comillas">
                <p>“</p>
              </div>

              <div className="slider_info">
                <p className="slider_info_title">{item3.summary}</p>
                <p className="slider_info_opinion">
                  {item3.review}
                </p>
                <p className="slider_info_autor">
                  {item3.name}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="slider">
          <figure className={claseNameMargin}>
          <ImageWebp
                srcWebp={item4.pathImgWebp}
                src={item4.pathImg}
                alt={item4.alts}
              /> 
          </figure>
          <div className={classNameCont}>
            <div className="slider_aux">
              <div className="slider_comillas">
                <p>“</p>
              </div>

              <div className="slider_info">
                <p className="slider_info_title">{item4.summary}</p>
                <p className="slider_info_opinion">
                  {item4.review}
                </p>
                <p className="slider_info_autor">
                  {item4.name}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="slider">
          <figure className={claseNameMargin}>
          <ImageWebp
                srcWebp={item5.pathImgWebp}
                src={item5.pathImg}
                alt={item5.alts}
              /> 
          </figure>
          <div className={classNameCont}>
            <div className="slider_aux">
              <div className="slider_comillas">
                <p>“</p>
              </div>

              <div className="slider_info">
                <p className="slider_info_title">{item5.summary}</p>
                <p className="slider_info_opinion">
                  {item5.review}
                </p>
                <p className="slider_info_autor">
                  {item5.name}
                </p>
              </div>
            </div>
          </div>
        </div>
 </AutoPlaySwipeableViews>

      <div className={classNameDots}>
        <Pagination dots={5} index={index} onChangeIndex={handleChangeIndex} />
      </div>
    </div>
  );
}

export default CarruselSlides;
